import { Component, Vue, Prop } from 'vue-facing-decorator'
import { ActionHandler } from "../helpers";
import type { MessageContentSettings, MessageStructureComponent } from "../types";

@Component
export default class QuickReply extends Vue {
  //property
	@Prop({
		type: Array,
		default: []
	})
	data?: MessageStructureComponent[];

	@Prop({
		type: Number,
		default: -1
	})
	msgIndex?: number;

	@Prop({
		type: Object,
		default() {
			return {}
		}
	})
	messageContentsettings?: MessageContentSettings

	/**
	 * This is used to determine if the font is fully loaded
	 */
	isFontLoaded = false;

	/**
	 * At this stage, the Vue instance has been initialized
	 */
	created() {
        this.listenEvents();
    }

    onClick(index) {
        ActionHandler.handleBtnClickAction(this.data[index]);
    }

	/**
	 * SD-1706
	 * This is used to listen to needed events
	 */
	listenEvents() {
		try {
			// Check if all fonts in use by visible text have loaded.
			(document as any).fonts.ready
				.then(() => {
					console.log('All fonts in use by visible text have loaded.');
					this.isFontLoaded = true;
				}).catch((err) => {
					this.isFontLoaded = true;
				});

		} catch (ex) {
            //var errorObj = { Page: 'quick_reply.ts', MethodName: 'listenEvents', Message: ex.message };
            //console.log(errorObj);
        }
	}
}
